import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import OperatorTable from '../components/OperatorTable';

const Operators = () => {
    return (
        <div className="d-flex entire-bg-color">
            <Sidebar />

            <div className="flex-grow-1">
                <DashboardNavbar />
                <div style={{marginTop: '70px'}}></div>

                <OperatorTable />


            </div>
        </div>
    );
};

export default Operators;